import { render, staticRenderFns } from "./MessageTemplateBuilder.vue?vue&type=template&id=58c83fce&scoped=true&"
import script from "./MessageTemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateBuilder.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateBuilder.vue?vue&type=style&index=0&id=58c83fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c83fce",
  null
  
)

export default component.exports